module.exports = __webpack_public_path__ + "img/totalsup.a7542c73.webp";